import React from 'react';
import {StreamBankLink} from "../../Common/StreamBankLink";

export const ContextTableColumn = props => {
    const link = props.rowData?.link || null;
    
    if (!link) {
        return "N/A";
    }
    
    return <StreamBankLink
        className="sb-actionable-link"
        Href={link + "/permit"}
    >
        {props.Value}
    </StreamBankLink>;
};
